<h3
  mat-dialog-title
  style="
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0%;
  "
>
  <div>Visualizar OS</div>
</h3>
<mat-dialog-content
  class="div-vertical-center div-center column-base"
  style="min-height: 470px; display: flex !important; gap: 20px"
>
  <div *ngIf="!loading && !messageError" class="divPDF">
    <iframe [attr.src]="url" width="900" height="400"> </iframe>
  </div>

  <mat-spinner *ngIf="loading" [diameter]="100"></mat-spinner>
  <span *ngIf="loading" class="loader-text">Cargando documento...</span>

  <span class="error-text" *ngIf="!loading && messageError">{{
    messageError
  }}</span>
</mat-dialog-content>
<mat-dialog-actions class="w-100 row-base div-end" style="gap: 30px">
  <button
    style="
      color: #e95a1a;
      border-color: #e95a1a !important ;
      min-width: 128px;
      text-align: center;
    "
    mat-stroked-button
    mat-dialog-close
  >
    Cerrar
  </button>
</mat-dialog-actions>
